import { Toaster } from "components/notification/Toaster";
import { func_serviceHandling, isNumberValid } from "functions";
import { useDispatch } from "react-redux"
import { 
    updateTrialStatus_request, updateTrialStatus_success, updateTrialStatus_failure, activateCOM_success, getAllComList_failure, 
    getAllComList_request, getAllComList_success, getComList_failure, getComList_request, getComList_success, updateExpiryDate_request, 
    updateExpiryDate_success, updateExpiryDate_failure, updatePaymentDueDate_request, updatePaymentDueDate_success, 
    updatePaymentDueDate_failure, suspendCOM_request, suspendCOM_success, suspendCOM_failure, activateCOM_request, activateCOM_failure, 
    resetPaymentDueDate_request, resetPaymentDueDate_success, resetPaymentDueDate_failure, updateDealerCode_request, updateDealerCode_success, 
    updateDealerCode_failure, updateBillingTag_request, updateBillingTag_success, updateBillingTag_failure, deleteCOM_request, 
    deleteCOM_success, deleteCOM_failure, revertDeletedCOM_request, revertDeletedCOM_success, revertDeletedCOM_failure, updatePackage_request, 
    updatePackage_success, updatePackage_failure, getPackages_request, getPackages_success, getPackages_failure,
	setSuspendDate_request, setSuspendDate_success, setSuspendDate_failure,
    removeSuspendDate_request, removeSuspendDate_success, removeSuspendDate_failure,
} from "../slices/accountControl.slices";
import usePromiseInstance_authorization from "./config"


export default function useAccountControlActions() {
    const dispatch = useDispatch();

    const request = usePromiseInstance_authorization();

    function getComList(pageNo, pageSize, sort, filterOptions) {
        dispatch(getComList_request());

        request(getComList_request, (axios) => {
            let isOffsetValid = isNumberValid(pageNo) && isNumberValid(pageSize);
            let offset = isOffsetValid? pageNo * pageSize:0;

            function getBooleanValue(value) {
                switch (value) {
                    case "Yes": return true;
                    case "No": return false;
                    case "Preset Only": return true;
                    case "No Preset": return false;
                    default: return undefined;
                }
            }
            
            let paramObj = {
                offset: offset,
                limit: pageSize,
                sort: sort,
                ...filterOptions,
                isSuspended: getBooleanValue(filterOptions?.isSuspended), 
                isTrial: getBooleanValue(filterOptions?.isTrial),
                deleted: getBooleanValue(filterOptions?.deleted),
                suspendDatePreset: getBooleanValue(filterOptions?.suspendDatePreset)
            }
    
            let url = func_serviceHandling.createUrlWithParams('/ComInfo/AccountControl/GetCom', paramObj);
            axios.get(url)
                .then((response) => {
                    dispatch(getComList_success(response));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load COM list";

                    dispatch(getComList_failure(msg));

					Toaster({ type: "error", msg });
                })
        })
    }

    function getAllComList(pageNo, pageSize, sort, filterOptions) {
        dispatch(getAllComList_request());

        request(getAllComList_request, (axios) => {
            let paramObj = {
                sort: sort,
                limit: 0,
                ...filterOptions
            }
    
            let url = func_serviceHandling.createUrlWithParams('/ComInfo/AccountControl/GetCom', paramObj);
            axios.get(url)
                .then((response) => {
                    dispatch(getAllComList_success(response.data));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load all COM list";

                    dispatch(getAllComList_failure(msg));

					Toaster({ type: "error", msg });
                })
        })
    }

    function updateExpiryDate(comId, newExpiryDate) {
        dispatch(updateExpiryDate_request());

        request(updateExpiryDate_request, (axios) => {
            let paramObj = {
                comId, newExpiryDate
            }
    
            let url = func_serviceHandling.createUrlWithParams("/ComInfo/AccountControl/UpdateExpiry", paramObj);
            axios.put(url)
                .then((response) => {
                    dispatch(updateExpiryDate_success());

                    Toaster({
                        type: "success",
                        msg: "Successfully updated expiry date"
                    })
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to update expiry date";

                    dispatch(updateExpiryDate_failure(msg));

					Toaster({ type: "error", msg });
                })
        })
    }

    function updatePaymentDueDate(comId, newPaymentDueDate, locationId) {
        dispatch(updatePaymentDueDate_request());

        request(updatePaymentDueDate_request, (axios) => {
            let paramObj = {
                comId, newPaymentDueDate, locationId
            }
    
            let url = func_serviceHandling.createUrlWithParams("/ComInfo/AccountControl/UpdatePaymentDue", paramObj);
            axios.put(url)
                .then((response) => {
                    dispatch(updatePaymentDueDate_success(response));

                    Toaster({
                        type: "success",
                        msg: "Successfully updated payment due date"
                    })
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to update payment due date";

                    dispatch(updatePaymentDueDate_failure(msg));

					Toaster({ type: "error", msg });
                })
        })
    }

    function resetPaymentDueDate(comId, locationId) {
        dispatch(resetPaymentDueDate_request());

        request(resetPaymentDueDate_request, (axios) => {
            let paramObj = {
                comId, locationId
            }

            let url = func_serviceHandling.createUrlWithParams("/ComInfo/AccountControl/UpdatePaymentDue", paramObj);

            axios.put(url)
                .then((response) => {
                    dispatch(resetPaymentDueDate_success(response));

                    Toaster({
                        type: "success",
                        msg: "Successfully reset payment due date"
                    })
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to reset payment due date";

                    dispatch(resetPaymentDueDate_failure(msg));

					Toaster({ type: "error", msg });
                })
        })
    }

    function suspendCOM(comID) {
        dispatch(suspendCOM_request());
            
        let comID_formatted = "";
        if (isNumberValid(comID)) comID_formatted = comID;

        request(suspendCOM_request, (axios) => {
            axios.put('/ComInfo/SuspendCom/' + comID_formatted)
                .then((response) => {
                    // handle success
                    dispatch(suspendCOM_success(response?.data));
                    Toaster({ type: "success", msg: "Successfully suspended COM(s)"});
                })
                .catch((error) => {
					// handle error
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to suspend COM";

                    dispatch(suspendCOM_failure(msg));

					Toaster({ type: "error", msg });
                })
        })
    }

    function deleteCOM(comID) {
        dispatch(deleteCOM_request());
            
        let comID_formatted = "";
        if (isNumberValid(comID)) comID_formatted = comID;

        request(deleteCOM_request, (axios) => {
            axios.delete('/ComInfo/AccountControl/DeleteCom?comId=' + comID_formatted)
                .then((response) => {
                    // handle success
                    dispatch(deleteCOM_success(response?.data));
                    Toaster({ type: "success", msg: "Successfully deleted COM(s)"});
                })
                .catch((error) => {
					// handle error
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to delete COM";

                    dispatch(deleteCOM_failure(msg));

					Toaster({ type: "error", msg });
                })
        })
    }

    function revertDeletedCOM(comID) {
        dispatch(revertDeletedCOM_request());
            
        let comID_formatted = "";
        if (isNumberValid(comID)) comID_formatted = comID;

        request(revertDeletedCOM_request, (axios) => {
            axios.put('/ComInfo/AccountControl/RevertDeleteCom?comId=' + comID_formatted)
                .then((response) => {
                    // handle success
                    dispatch(revertDeletedCOM_success(response?.data));
                    Toaster({ type: "success", msg: "Successfully reverted deleted COM(s)"});
                })
                .catch((error) => {
					// handle error
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to revert deleted COM";

                    dispatch(revertDeletedCOM_failure(msg));

					Toaster({ type: "error", msg });
                })
        })
    }

    function activateCOM(comID) {
        dispatch(activateCOM_request());
            
        let comID_formatted = "";
        if (isNumberValid(comID)) comID_formatted = comID;

        request(activateCOM_request, (axios) => {
            axios.put('/ComInfo/ReactiveCom/' + comID_formatted)
                .then((response) => {
                    // handle success
                    dispatch(activateCOM_success(response?.data));
                    Toaster({ type: "success", msg: "Successfully active COM " + comID_formatted});
                })
                .catch((error) => {
					// handle error
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to activate COM";

                    dispatch(activateCOM_failure(msg));

					Toaster({ type: "error", msg });
                })
        })
    }

    function updateTrialStatus(comId, isOldStatusTrial) {
        dispatch(updateTrialStatus_request());
            
        let paramObj = {
            comId, 
            isTrial: isOldStatusTrial
        }

        let url = func_serviceHandling.createUrlWithParams('/ComInfo/AccountControl/UpdateTrialStatus', paramObj);
        

        request(updateTrialStatus_request, (axios) => {
            axios.put(url)
                .then((response) => {
                    // handle success
                    dispatch(updateTrialStatus_success(response?.data));
                    Toaster({ type: "success", msg: "Successfully updated COM " + comId + " " + (!isOldStatusTrial? "to trial": "to not trial")});
                })
                .catch((error) => {
					// handle error
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to update trial status";

                    dispatch(activateCOM_failure(msg));

					Toaster({ type: "error", msg });
                })
        })
    }

    function updateDealerCode(comId, newDealerCode) {
        dispatch(updateDealerCode_request());

        request(updateDealerCode_request, (axios) => {
            let paramObj = {
                comId, newDealerCode
            }
    
            let url = func_serviceHandling.createUrlWithParams("/ComInfo/AccountControl/UpdateDealerCode", paramObj);

            axios.put(url)
                .then((response) => {
                    dispatch(updateDealerCode_success(response));

                    Toaster({
                        type: "success",
                        msg: "Successfully updated dealer code"
                    })
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to update dealer code";

                    dispatch(updateDealerCode_failure(msg));

					Toaster({ type: "error", msg });
                })
        })
    }

    function updateBillingTag(comId, newBillingTag) {
        dispatch(updateBillingTag_request());

        request(updateBillingTag_request, (axios) => {
            let paramObj = {
                comId, billingTag: newBillingTag
            }
    
            let url = func_serviceHandling.createUrlWithParams("/ComInfo/AccountControl/UpdateBillingTag", paramObj);

            axios.put(url)
                .then((response) => {
                    dispatch(updateBillingTag_success(response));

                    Toaster({
                        type: "success",
                        msg: "Successfully updated billing tag"
                    })
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to update billing tag";

                    dispatch(updateBillingTag_failure(msg));

					Toaster({ type: "error", msg });
                })
        })
    }

    function getPackages(packageId) {
        dispatch(getPackages_request());

        request(getPackages_request, (axios) => {
            
            let paramObj = {
                packageId
            }
    
            let url = func_serviceHandling.createUrlWithParams('/ComInfo/AccountControl/GetAvailablePackageForBilling', paramObj);
            axios.get(url)
                .then((response) => {
                    dispatch(getPackages_success(response));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load package list";

                    dispatch(getPackages_failure(msg));

					Toaster({ type: "error", msg });
                })
        })
    }

    function updatePackage(comId, packageId) {
        dispatch(updatePackage_request());

        request(updatePackage_request, (axios) => {
            let paramObj = {
                comId, 
                subsPackageId: packageId
            }
    
            let url = func_serviceHandling.createUrlWithParams("/ComInfo/AccountControl/UpdateSubsPackage", paramObj); // ISSUE: needs to be updates

            axios.put(url)
                .then((response) => {
                    dispatch(updatePackage_success(response));

                    Toaster({
                        type: "success",
                        msg: "Successfully updated package"
                    })
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to update package";

                    dispatch(updatePackage_failure(msg));

					Toaster({ type: "error", msg });
                })
        })
    }

    function updateSuspendDate(comId, suspendDate) {
        dispatch(setSuspendDate_request());

        request(setSuspendDate_request, (axios) => {
            let paramObj = {
                suspendDate
            }
    
            let url = func_serviceHandling.createUrlWithParams(`/ComInfo/SetComSuspendDate/${comId}`, paramObj);
            axios.put(url)
                .then((response) => {
                    dispatch(setSuspendDate_success());

                    Toaster({
                        type: "success",
                        msg: "Successfully set suspend date"
                    })
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to set suspend date";

                    dispatch(setSuspendDate_failure(msg));

					Toaster({ type: "error", msg });
                })
        })
    }

    function removeSuspendDate(comID) {
        dispatch(removeSuspendDate_request());

        let comID_formatted = "";
        if (isNumberValid(comID)) comID_formatted = comID;

        request(removeSuspendDate_request, (axios) => {
            axios.delete('/ComInfo/RemoveComSuspendDate/' + comID_formatted)
                .then((response) => {
                    dispatch(removeSuspendDate_success(response));

                    Toaster({
                        type: "success",
                        msg: "Successfully removed suspend date"
                    })
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage ? error.response.data.exceptionMessage : "Failed to remove suspend date";

                    dispatch(removeSuspendDate_failure(msg));

                    Toaster({ type: "error", msg });
                })
        })
    }

    
    return {
        getComList, getAllComList,
        updateExpiryDate, updatePaymentDueDate, resetPaymentDueDate,
        suspendCOM, activateCOM, deleteCOM, revertDeletedCOM,
        updateTrialStatus, updateDealerCode, updateBillingTag, 
        getPackages, updatePackage, updateSuspendDate, removeSuspendDate
    }
}